import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../loader.service';

interface loaderStorage {
	element: HTMLDivElement;
	visible: boolean;
}

@Component({
	selector: 'app-loader',
	template: '',
	styleUrls: ['./loader.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class LoaderComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];
	private storage: loaderStorage;

	constructor(private loaderService: LoaderService) {
		this.storage = {
			element: document.createElement('div'),
			visible: false,
		};
		this.storage.element.className = 'spinner hidden';
		this.storage.element.innerHTML = '<div class="spinner-wrapper"><div class="itoSpinner itoSpinMixed"><div class="ito1"></div><div class="ito2"></div><div class="ito3"></div></div></div>';
		document.body.appendChild(this.storage.element);
	}

	ngOnInit() {
		this.subscriptions.push(
			this.loaderService.loaderState.subscribe(isLoading => {
				setTimeout(() => {
					this.storage.visible = isLoading;
					if (isLoading == true) {
						this.storage.element.classList.remove('hidden');
					} else {
						this.storage.element.classList.add('hidden');
					}
				});
			}),
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(sub => {
			sub.unsubscribe();
		});
		setTimeout(() => {
			document.body.removeChild(this.storage.element);
		});
	}
}
